export const SMART_DROPDOWN_FILE_UPLOAD = "SMART_DROPDOWN_FILE_UPLOAD"
export const SMART_DROPDOWN_FILE_UPLOAD_SUCCESS = "SMART_DROPDOWN_FILE_UPLOAD_SUCCESS"
export const SMART_DROPDOWN_FILE_UPLOAD_ERROR = "SMART_DROPDOWN_FILE_UPLOAD_ERROR"

export const SMART_DROPDOWN_NOTIFICATION_UPLOAD_FILES = "SMART_DROPDOWN_NOTIFICATION_UPLOAD_FILES"
